import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import { CheckSquareIcon } from "lucide-react";
import Badge from "./Badge";

type Story = ComponentStory<typeof Badge>;

const commonArgs: React.ComponentProps<typeof Badge> = {
    text: "Passive",
    icon: true,
    tooltip: "Delivery unsuccessful"
};

export default {
    title: "common/Badge",
    component: Badge,
    args: commonArgs
} as ComponentMeta<typeof Badge>;

const Template: Story = args => (
    <div style={{ width: 150 }}>
        <Badge {...args} />
    </div>
);

export const Default = Template.bind({});

export const NoIcon = Template.bind({});
NoIcon.args = {
    text: "Active",
    variant: "secondary",
    icon: false
};

export const Secondary = Template.bind({});
Secondary.args = {
    text: "Processing",
    variant: "secondary"
};

export const Tertiary = Template.bind({});
Tertiary.args = {
    text: "Announced",
    variant: "tertiary"
};

export const Success = Template.bind({});
Success.args = {
    text: "Completed",
    variant: "success"
};

export const Error = Template.bind({});
Error.args = {
    text: "Blocked",
    variant: "error"
};

export const Custom = Template.bind({});
Custom.args = {
    text: "Handling completed",
    icon: <CheckSquareIcon />,
    bgColor: "#E0FCF5",
    color: "#197368",
    iconColor: "#19A18D"
};

export const Overflow = Template.bind({});
Overflow.args = {
    text: "Unexpectedly big content"
};
